module.exports = __webpack_public_path__ + "img/img18.dd795f7c.png";